export const breadcrumbs = {
  breadcrumbHome: "Inicio",
  breadcrumbCasino: "Casino",
  breadcrumbLottery: "Lotería",
  breadcrumbRaffles: "Sorteos",
  breadcrumbNews: "Noticias",
  breadcrumbArticle: "Artículo",
  breadcrumbSports: "Deportes",
  breadcrumbGameFeed: "Novedades",
  breadcrumbMyTickets: "Mis Tickets",
  breadcrumbResults: "Resultados",
  breadcrumbAllGames: "Todos los Juegos",
  breadcrumbGames: "Juegos",
  breadcrumbTerms: "Términos y Condiciones",
  breadcrumbDeleteAccount: "Eliminar Cuenta",
  breadcrumbProfile: "Perfil",
  breadcrumbProvider: "Proveedor",
  breadcrumbHorses: "Caballos",
  breadcrumbMiniJuegos: "Mini Juegos",
  breadcrumbFavorites: "Favoritos",
};
